export default "__VITE_ASSET__oShNS9dH__"